const BASE_FONT_SIZE = 16;
export const scaleFont = (baseFontSize = BASE_FONT_SIZE, prevFontSize: number) => {

  return baseFontSize + (prevFontSize - BASE_FONT_SIZE);
};
